/**
 * Handles API errors by creating a "soft 404".
 * If the error is a 404, it allows the component to render but prevents search engine
 * indexing and sets the correct HTTP 404 status on the server.
 * Any other critical errors (e.g., 500) are delegated to the default error handler.
 * * @param error - The error object or ref returned by useAsyncData/useFetch
 */
export const useSoft404 = async (error: any) => {
	const err = unref(error);

	if (!err) {
		return;
	}

	const is404 = err.statusCode === 404 || err.status === 404;

	if (is404) {
		useHead({meta: [{name: 'robots', content: 'noindex'}]});

		if (import.meta.server) {
			const event = useRequestEvent();
			if (event) {
				setResponseStatus(event, 404);
			}
		}
	} else {
		await tryDynamicRedirectOrShowError(err);
	}
};
